import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedSearch: [],
  savedSearchError: '',
  savedSearchLoading: false,
};

export const savedSearchSlice = createSlice({
  name: "savedSearch",
  initialState,
  reducers: {
    fetchSavedSearch: (state) => {
      state.savedSearchLoading = true;
    },
    fetchSavedSearchSuccess: (state, action) => {
      state.savedSearchLoading = false;
      state.savedSearch = action.payload;
      state.savedSearchError = '';
    },
    fetchSavedSearchFailure: (state, action) => {
      state.savedSearchLoading = false;
      state.savedSearchError = action.payload;
    },
  },
});

export const {
  fetchSavedSearch,
  fetchSavedSearchSuccess,
  fetchSavedSearchFailure,
} = savedSearchSlice.actions;
export const savedSearchData = (state) => (state.savedSearch)
export default savedSearchSlice.reducer;